import { createRoot } from 'react-dom/client';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import AppRouter from './router.jsx'
import './app.css'

dayjs.locale('zh-cn');

const root = createRoot(document.getElementById('root'));
root.render(
  <>
  {/* 全局关闭 antd 动画：v6 的关闭动画可能卡在 leave-start，导致全屏遮罩残留、页面无法点击/输入 */}
  {/* 中文 locale：表格筛选等内置文案使用中文 */}
  <ConfigProvider
    locale={zhCN}
    theme={{ token: { motion: false } }}
  >
    <AppRouter />
  </ConfigProvider>
  </>
)
